/**
 * Leaderboard Service
 * Fetches grade-level leaderboard data
 */

import { apiClient, extractData } from './api';
import type { LeaderboardResponse } from '@kids-lms/types';

export async function getLeaderboard(
  childId: string,
  period: 'weekly' | 'alltime' = 'weekly'
): Promise<LeaderboardResponse> {
  const response = await apiClient.get<{ success: boolean; data: LeaderboardResponse }>(
    `/leaderboard`,
    { params: { childId, period } }
  );
  return extractData(response);
}
